var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{
    'position-right': _vm.config.position == 'right',
    'position-left': _vm.config.position == 'left',
    'position-fixed': !_vm.display,
  }},[_c('div',{staticClass:"container",class:{
      'element-hide': !_vm.display,
      rtl: _vm.dir === 'rtl',
    }},[_c('router-view')],1),_c('div',{staticClass:"toggle",class:{
      'toggle-right': _vm.config.position == 'right',
      'toggle-left': _vm.config.position == 'left',
      'toggle-hide': _vm.display,
      'bubble-show': _vm.config.bubble && _vm.showBubble,
    }},[(_vm.config.bubble && _vm.showBubble)?_c('div',{staticClass:"bubble"},[_c('img',{staticClass:"quotation",attrs:{"src":require("@/assets/images/icons/quotation.png"),"alt":"quotation"}}),_c('div',{staticClass:"close",on:{"click":function($event){_vm.showBubble = false}}},[_c('img',{attrs:{"src":require("@/assets/images/icons/close.png"),"alt":"close"}})]),_c('p',[_vm._v(" 嗨！要了解關於產品規格、比較產品，還是查詢訂單問題，隨時找我就對了！ ")])]):_vm._e(),_c('img',{attrs:{"src":require("@/assets/images/avatar-genio60.svg"),"alt":"genio","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.toggleDisplay.apply(null, arguments)},"click":_vm.toggleDisplay}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }